<template>
  <el-container>
    <router-view></router-view>
  </el-container>
</template>

<script>
export default {
  name: 'DashBoard'
}
</script>
